import { Component, OnDestroy, OnInit, ElementRef, ViewChild, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { Subscription } from 'rxjs';
import { PropertyDocumentType, PropertyDocumentTypeToString } from '../../model/const/documentEnums';
import { SelectionItem } from '../../../core/component/select/select.component';
import { PropertyDocument } from '../../model/property-document';
import { PropertyDocumentService } from '../../service/data/property-document-service';
import { Property } from '../../model/property';

@Component({
    selector: 'app-property-document-form',
    templateUrl: './property-document-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PropertyDocumentFormComponent implements OnDestroy, OnInit {
  constructor(
    private _actionService: ActionWindowService,
    private _dataService: PropertyDocumentService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory,
    private _renderer: Renderer2
  ) {}

  private _subscription: Subscription = new Subscription();
  dataContext: Property;
  form: FormGroup;

  connectionTypes: SelectionItem[];

  cancel() {
    this._actionService.close();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    this._subscription = null;
  }

  ngOnInit() {
    this.connectionTypes = [
      PropertyDocumentType.General,
      PropertyDocumentType.PlanDrawing,
      PropertyDocumentType.FacadeDrawing,
      PropertyDocumentType.SituationPlan,
      PropertyDocumentType.InspectionReport,
      PropertyDocumentType.Protocol,
      PropertyDocumentType.Agreement,
      PropertyDocumentType.Photo,
    ].map(t => new SelectionItem(PropertyDocumentTypeToString(t), t));

    this.form = this._fb.group({
      caption: this._fcf.createMandatory('LEASE_AGREEMENT_DOCUMENT.CAPTION', ''),
      connectionType: this._fcf.createMandatory('DOCUMENT.DOCUMENT_TYPE', PropertyDocumentType.General),
      document: this._fcf.createMandatory('', null),
      contact: this._fcf.createHidden(this.dataContext.id),
    });
  }

  onFileChange(files: FileList) {
    if (files && files.length === 1) {
      this.form.controls['document'].setValue(files[0]);
      this.form.controls['caption'].setValue(files[0].name.substr(0, files[0].name.lastIndexOf('.')));
    } else {
      this.form.controls['caption'].reset();
    }
  }

  onSubmit() {
    if (this.form.valid) {
      this._subscription.add(
        this._dataService.add(Object.assign(new PropertyDocument(), this.form.value)).subscribe(() => this._actionService.complete(true))
      );
    }
  }
}
